{
  "maximum": "Максимум",
  "minimum": "Мінімум"
}
